import { useState } from "react";
import { AdminModules } from "../../parameters/features";
// import { DetailsView } from "./detailsView";
import { useNavigate } from "react-router-dom";
import {
  ConfirmationDeleteModal,
  useLanguageTranslator,
} from "../../../../components";
import { gql, useMutation } from "@apollo/client";
import { useApolloQuery } from "../../../../hooks";
import dayjs from "dayjs";
import { useNotify } from "../../../../components/@common/NotificationsProvider";
import { useAuthSession } from "../../../../components/AuthSessionProvider";
import { DetailsView } from "./detailsView";

const GET_PROFILE_WITH_PAGINATION = gql`
  query GetUsers($page: Int!) {
    users(page: $page) {
      collection {
        companyName
        email
        firstName
        id
        isConfirmed
        isLocked
        lang
        lastName
        createdAt
        updatedAt
        password
        profile {
          name
        }
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

const DELETE_PROFILE = gql`
  mutation DeleteUser($id: ID!) {
    userDeleteByAdmin(input: { id: $id }) {
      clientMutationId
      user {
        id
        firstName
        lastName
        email
        companyName
        createdAt
        updatedAt
        isConfirmed
        isLocked
        lang
        profile {
          name
        }
      }
    }
  }
`;

function Profiles() {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isOpen, setIsOpen] = useState({ status: false, data: {} });
  const [isOpenDelete, setIsOpenDelete] = useState({ status: false, data: {} });

  const navigate = useNavigate();
  const { translator } = useLanguageTranslator();
  const notify = useNotify();
  const { user } = useAuthSession() as any;

  const { data, loading, refetch } = useApolloQuery({
    queryDocument: GET_PROFILE_WITH_PAGINATION,
    isPrivateCall: true,
    variables: {
      page: page,
    },
  });

  const [deleteProfile, { loading: deleteLoading, error }] = useMutation(
    DELETE_PROFILE,
    {
      context: {
        headers: {
          "access-token": user?.accessToken,
          client: user?.client,
          uid: user?.email,
        },
      },
    }
  );

  const modifiedProfileList = data?.users?.collection?.map((item: any) => {
    return {
      sr: item?.id,
      id: item?.id,
      profile: `Administrator`,
      createdAt: dayjs(item?.createdAt?.split("T")?.[0] || "").format(
        "DD.MM.YYYY"
      ),
      updatedAt: dayjs(item?.updatedAt?.split("T")?.[0] || "").format(
        "DD.MM.YYYY"
      ),
    };
  });

  async function onClickHandler(type: string, clickedItem: any) {
    if (type === "view") {
      setIsOpen({ status: true, data: clickedItem });
      return;
    }
    if (type === "edit") {
      navigate(`/admin/profiles/update?id=${clickedItem}`);
      return;
    }

    if (type === "delete") {
      setIsOpenDelete({ status: true, data: { id: clickedItem } });
    }
  }

  function handleCancel() {
    setIsOpen({ status: false, data: {} });
  }

  const columns = [
    { id: "sr", label: "ID", minWidth: "100%", align: "left" },
    {
      id: "profile",
      label: translator("generic.Profile"),
      minWidth: "100%",
      align: "left",
    },
    {
      id: "createdAt",
      label: translator("dashboardTableHead.Date Created"),
      minWidth: "100%",
      align: "left",
    },
    {
      id: "updatedAt",
      label: translator("dashboardTableHead.Date Updated"),
      minWidth: "100px",
      align: "left",
    },
    {
      id: "id",
      label: translator("dashboardTableHead.Action"),
      minWidth: "100%",
      align: "right",
    },
  ];

  async function onClickDeleteHandler(item: any) {
    const response = await deleteProfile({
      variables: { id: Number(item?.id) },
    });
    if (response?.data) {
      notify.success(`Profile Deleted successfully!`);
      setIsOpenDelete({ status: false, data: {} });
      setIsOpen({ status: false, data: {} });
      setTimeout(async () => {
        await refetch();
      }, 1000);
    }
  }

  function handleDeleteClose() {
    setIsOpenDelete({ status: false, data: {} });
  }

  function onClickDetailHandler(item: any) {
    setIsOpenDelete({ status: true, data: { id: item?.id } });
  }

  return (
    <>
      <ConfirmationDeleteModal
        isOpen={isOpenDelete?.status}
        item={isOpenDelete?.data}
        onClickHandler={onClickDeleteHandler}
        handleClose={handleDeleteClose}
      />
      <DetailsView
        isOpen={isOpen?.status}
        item={isOpen?.data}
        handleCancel={handleCancel}
        onClickHandler={onClickDetailHandler}
      />
      <AdminModules
        title={translator("Profiles")}
        path="/admin/profiles/add-new"
        data={[]}
        moduleKey="profile-module"
        page={page}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        setPage={setPage}
        onClickHandler={onClickHandler}
        metadata={data?.users?.metadata}
        isView={true}
        isAccounts={true}
        tableColumns={columns}
      />
    </>
  );
}

export { Profiles };
